// extracted by mini-css-extract-plugin
export default {"body":"layout_body__dy48S","main__container":"layout_main__container__We12s","layout":"layout_layout__Deyd0","footer":"layout_footer__uzjy+"};